import { useSelector } from 'react-redux';
import { selectServiceProviders } from 'redux-store/features/service-providers/service-providers.selectors';

export const useServiceProviders = () => useSelector(selectServiceProviders);
